/**
 * Get the error message out of a potential Error class
 * @returns a string representing the details of the error
 */
export const getDisplayedErrorMessage = (err: unknown): string => {
  if (err instanceof Error) {
    return err.message;
  }

  try {
    let msg = err?.toString();

    if (msg) return msg;

    msg = JSON.stringify(err);

    if (msg) return msg;
  } catch (err) {
    // ignore
  }

  return "";
};
